/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { ExperienceLevel, InvestmentClass } from '../types/utils';

export class UpdateSkillInput {
	hasKnowledge: boolean = false

	level: ExperienceLevel = ExperienceLevel.NONE

	type: InvestmentClass = InvestmentClass.INVESTMENT_FUND
}